import { useState, useEffect } from 'react';
import { ManText, ManSelect, ManSelectItem, ManInputText, ManDatepicker } from "@craft-design-system/core-components-react";
import Shimmer from "./Shimmer";
import useDropdownData from '../utils/dropdown_data_loading/useDropdownData';
import useDynamicFiltering from '../utils/dropdown_data_loading/useDynamicFiltering';
import { Collapse } from 'reactstrap';
import filters from '../assets/images/filters.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import Select from 'react-select';
import 'react-tooltip/dist/react-tooltip.css';

import { useFilterContext } from './FilterContext';
import { useDynamicContext } from './DynamicContext';
import { useResetContext } from './ResetContext';
import { useDeselectContext } from './DeselectContext';
import { useGraphContext } from '../GraphContext';
import FilterSidebar from './FilterSidebar';

const Bus_filters = (props) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedValues, setSelectedValues] = useState({});
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [dropdownData, setDropdownStates] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { resetdata, updateresetdata, clearGraphData } = useResetContext();
  const { deselectdata, updatedeselectdata } = useDeselectContext();
  const { filterdata, updateFilterData } = useFilterContext();
  const { dynamicdata, updatedynamicdata } = useDynamicContext();
  const { graphData, updateGraphData } = useGraphContext();

  const { dynamicFiltering, dropdownInfo } = useDynamicFiltering();
  const { dropdowndata, fetchData, isRefreshing } = useDropdownData();

  const handleSelectChange = (selectedOptions, columnName) => {

    console.log('startdatebus', startDate);
    setSelectedValues(prevValues => {
      const newValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
      const updatedValues = {
        ...prevValues,
        [columnName]: newValues,
        button_clicked: false,
        username: props.username
      };
      updateFilterData(updatedValues);
      return updatedValues;
    });
    setIsInitialLoad(false);
  };

  const handleDateChange = (date, type) => {
    const newStartDate = type === 'start' ? date : startDate;
    const newEndDate = type === 'end' ? date : endDate;

    setStartDate(newStartDate);
    setEndDate(newEndDate);

    setSelectedValues(prevValues => {
      const updatedValues = {
        ...prevValues,
        startDate: newStartDate?.toISOString() || null,
        endDate: newEndDate?.toISOString() || null,
      };
      updateFilterData(updatedValues);
      return updatedValues;
    });
  };

  const handleValuesChange = (minValue, maxValue) => {
    setSelectedValues(prevValues => {
      const updatedValues = {
        ...prevValues,
        'Total mileage [km]': [minValue, maxValue],
      };
      updateFilterData(updatedValues);
      return updatedValues;
    });
  };

  useEffect(() => {
    setDropdownStates(dropdowndata);
    setSelectedValues(null);
  }, [dropdowndata]);

  useEffect(() => {
    if (deselectdata !== null) {
      setSelectedValues(prev => {
        const updated = { ...prev };
        updated[deselectdata] = [];
        return updated;
      });
    }
  }, [deselectdata]);

  useEffect(() => {
    setDropdownStates(dynamicdata);
  }, [dynamicdata]);

  useEffect(() => {
    if (resetdata === 'Bus1') {
      fetchData();
      setDropdownStates(dropdowndata);
      setSelectedValues(null);
    }
  }, [resetdata]);

  if (!dropdownData || isRefreshing) return <Shimmer />;

  return (
    <FilterSidebar
      dropdownData={dropdownData}
      selectedValues={selectedValues}
      handleSelectChange={handleSelectChange}
      customStyles={{
        dropdownIndicator: (provided) => ({ ...provided, color: 'red' }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isSelected ? 'grey' : state.isFocused ? '#EAEDF3' : null,
          color: state.isSelected ? 'white' : 'black',
        }),
        control: (provided) => ({
          ...provided,
          borderRadius: '1px',
          borderWidth: '1px',
          borderColor: '#5B6F85',
          cursor: 'pointer',
        }),
        multiValue: (styles) => ({ ...styles }),
        valueContainer: (styles) => ({
          ...styles,
          display: 'flex',
          flexWrap: 'nowrap',
          overflowX: 'auto',
        }),
      }}
      onvaluesChange={handleValuesChange}
      startDate={startDate}
      endDate={endDate}
      onDateChange={handleDateChange}
    />
  );
};

export default Bus_filters;
